module.exports = __webpack_public_path__ + "static/media/social-comments.290e3130.svg";